<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import SancareOcticon from '../../components/SancareOcticon.vue'

defineOptions({
  inheritAttrs: false,
})

const { t } = useI18n()

const model = defineModel<string>({ default: '' })

const isVisible = ref(false)
const inputRef = ref<HTMLInputElement | null>(null)

function toggleVisibility(): void {
  isVisible.value = !isVisible.value
  inputRef.value?.focus()
}

defineExpose({
  focus: () => inputRef.value?.focus(),
})
</script>

<template>
  <div
    class="sancare-password-input position-relative"
    :class="$attrs.class"
  >
    <input
      ref="inputRef"
      v-model="model"
      v-bind="$attrs"
      :type="isVisible ? 'text' : 'password'"
      class="form-control sancare-password-input__input"
    >
    <button
      v-tooltip="isVisible ? t('passwordInput.hide') : t('passwordInput.show')"
      type="button"
      class="sancare-password-input__toggle"
      tabindex="-1"
      :aria-label="isVisible ? t('passwordInput.hide') : t('passwordInput.show')"
      @mousedown.prevent
      @click="toggleVisibility"
    >
      <sancare-octicon
        :name="isVisible ? 'eye-closed' : 'eye'"
        :width="16"
      />
    </button>
  </div>
</template>

<style lang="scss" scoped>
.sancare-password-input {
  &__input {
    padding-right: 2.25rem;
  }

  &__toggle {
    position: absolute;
    top: 50%;
    right: .5rem;
    transform: translateY(-50%);
    display: inline-flex;
    align-items: center;
    padding: 0;
    border: none;
    background: none;
    color: var(--bs-secondary-color);
    cursor: pointer;

    &:hover {
      color: var(--bs-body-color);
    }
  }
}
</style>
